module.exports = __webpack_public_path__ + "img/icon-ticket-win.9ce16bf6.svg";